(function () {
  var SELECTOR = '.product-title-judgeme .jdgm-prev-badge';
  var TEXT_SELECTOR = '.jdgm-prev-badge__text';

  function parseReviewCount(badge) {
    var rawCount = badge.getAttribute('data-number-of-reviews') || badge.dataset.numberOfReviews || '';
    var count = parseInt(String(rawCount).replace(/[^\d]/g, ''), 10);

    if (Number.isNaN(count)) {
      var text = badge.textContent || '';
      var textCount = parseInt(text.replace(/[^\d]/g, ''), 10);
      count = Number.isNaN(textCount) ? 0 : textCount;
    }

    return Math.max(0, count);
  }

  function formatReviewText(count) {
    if (count === 0) return 'Seja o primeiro a avaliar';
    if (count === 1) return '1 avaliação';
    return count + ' avaliações';
  }

  function ensureTextElement(badge) {
    var textElement = badge.querySelector(TEXT_SELECTOR);

    if (!textElement) {
      textElement = document.createElement('span');
      textElement.className = 'jdgm-prev-badge__text';
      badge.appendChild(textElement);
    }

    return textElement;
  }

  function normalizeBadge(badge) {
    if (!badge || badge.dataset.soulReviewNormalizing === 'true') return;

    var count = parseReviewCount(badge);
    var label = formatReviewText(count);
    var textElement = ensureTextElement(badge);

    badge.dataset.soulReviewNormalizing = 'true';
    badge.dataset.soulReviewCount = String(count);

    if (badge.getAttribute('data-number-of-reviews') !== String(count)) {
      badge.setAttribute('data-number-of-reviews', String(count));
    }

    if (textElement.textContent !== label) {
      textElement.textContent = label;
    }

    badge.setAttribute('aria-label', label);
    delete badge.dataset.soulReviewNormalizing;
  }

  function normalizeBadges(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(normalizeBadge);
  }

  document.addEventListener('DOMContentLoaded', function () {
    normalizeBadges(document);

    var observer = new MutationObserver(function (mutations) {
      var shouldNormalize = false;

      mutations.forEach(function (mutation) {
        if (shouldNormalize) return;

        if (mutation.target && mutation.target.closest && mutation.target.closest('.product-title-judgeme')) {
          shouldNormalize = true;
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (shouldNormalize || !node.querySelectorAll) return;
          shouldNormalize = Boolean(node.matches && node.matches(SELECTOR)) || Boolean(node.querySelector(SELECTOR));
        });
      });

      if (shouldNormalize) {
        window.requestAnimationFrame(function () {
          normalizeBadges(document);
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-number-of-reviews']
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    normalizeBadges(event.target);
  });
})();
